import Layout from "../../../Components/Layout";
import MyEvents from "../../../Components/EventMgt/MyEvents";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const MyEventsPage = () => {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);

  return (
    <Layout
      activeMenuId="my-created-events"
      SecondaryButtonHeading={
        userDetails.userType === "organizer" && "Create Event"
      }
      SecondaryButtonAction={() => navigate("/myEvents/create/basic_info")}
      SecondaryButtonIcon="bi-calendar-plus"
    >
      <MyEvents />
    </Layout>
  );
};
export default MyEventsPage;
